import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slide from "../Slide/Slide";

const CustomPrevArrow = (props) => {
    const { onClick } = props;
    return (
        <div className="custom-arrow custom-prev" onClick={onClick}
             style={{
                 position: 'absolute',
                 top: '50%',
                 left: '14px', // Adjust the left position as needed
                 transform: 'translateY(-50%)',
                 cursor: 'pointer',
                 zIndex: 1,
             }}
        >
            <FontAwesomeIcon icon={faChevronLeft} style={{ fontSize: '64px', color: 'white' }} />
        </div>
    );
};

const CustomNextArrow = (props) => {
    const { onClick } = props;
    return (
        <div className="custom-arrow custom-next" onClick={onClick}
             style={{
                 position: 'absolute',
                 top: '50%',
                 right: '33px', // Adjust the right position as needed
                 transform: 'translateY(-50%)',
                 cursor: 'pointer',
                 zIndex: 1,
             }}
        >
            <FontAwesomeIcon icon={faChevronRight} style={{ fontSize: '64px', color: 'white' }} />
        </div>
    );
};

const Recommendtv = ({ tvId }) => {
    const API_KEY = '4aec7e88f4dca5e1ca73d50a3b06579a';
    const [recommendations, setRecommendations] = useState([]);

    useEffect(() => {
        const fetchRecommendations = async () => {
            try {
                const response = await fetch(`https://api.themoviedb.org/3/tv/${tvId}/recommendations?language=en-US&page=1&api_key=${API_KEY}`);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                setRecommendations(data.results);
            } catch (error) {
                console.error('There was a problem with the fetch operation:', error);
            }
        };

        fetchRecommendations();
    }, [tvId]);

    const slickSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        centerMode: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 2,
                },
            },
        ],
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />,
    };


    return (
        <div>
            <h2>Recommendations</h2>
            <Slider {...slickSettings} className="banner">
                {recommendations.length > 0 ? (
                    recommendations.map((tv, index) => (
                        <Slide key={tv.id} tv={tv} index={index} />
                    ))
                ) : (
                    <p>No recommendations found.</p>
                )}
            </Slider>
        </div>
    );
};

export default Recommendtv;